module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xT68Kc/tc-custom/9781423607984.jpg?1721404702129",
      "alt": "This image is the cover for the book Southern Farmers Market Cookbook"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Southern Farmers Market Cookbook\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Learn how to shop better at local farmers markets and how to transform what you buy into a tasty, refreshing, and healthy meal.")]), _c('br'), _c('br'), _vm._v(" The time to eat healthy and buy locally has arrived. Buying at farmers markets means getting better, fresh-picked produce that leads to amazing home-cooked meals. "), _c('i', [_vm._v("Southern Farmers Market Cookbook")]), _vm._v(" teaches how to enjoy shopping at local markets and gives instruction on what to look for and what’s to be expected to make the experience more fulfilling and fun."), _c('br'), _c('br'), _vm._v(" More than 75 seasonal recipes show how to take these delicious fresh foods from market to table in mouthwatering ways. Try the crisp Butter Bean and Grape Tomato Bruschetta, the sweet Wild Honey-Glazed Carrots with Mint and Green Onions, the savory Wine-Poached Salmon with Cucumber Crudité Sauce, and the luscious Warm Wild Cherry Carolina Gold Rice Pudding."), _c('br'), _c('br'), _vm._v(" While "), _c('i', [_vm._v("Southern Farmers Market Cookbook ")]), _vm._v("features produce grown in South Carolina, North Carolina, Georgia, Alabama, Mississippi, Florida, Kentucky, and Tennessee, many of the same foods can be purchased locally in most areas of the country. This book also includes state-by-state seasonal produce charts and state-by-state farmers market listings.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Holly Herrick\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0